import React, { useContext, useState } from "react";

import { useHistory } from "react-router-dom";

import { ALL_TARIFFS_QUERY } from "../../../graphql/Tariffs/Tariffs.graphql";

import { AddTariffForm } from "../../../components/Tariffs";

import { ModalContext } from "../../../components/ModalProvider";

import DataTable from "../../../components/DataTable";

import { COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";

import TariffFilters from "./TariffFilters";
import { getFilterState, saveFilterState } from "../../../utils";

const TariffsPage = () => {
  const history = useHistory();

  const INITIAL_FILTER_STATE = getFilterState("TARIFF_FILTERS", {
    Active: true
  });

  const { setModalOpen } = useContext(ModalContext);
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("TARIFF_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={TariffFilters}
        columns={COLUMNS}
        filters={filters}
        name="Tariffs"
        query={ALL_TARIFFS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Tariffs"
        onAddClick={() =>
          setModalOpen(true, <AddTariffForm setModalOpen={setModalOpen} />)
        }
      />
      <DataTable
        columns={COLUMNS}
        dataQuery={ALL_TARIFFS_QUERY}
        initialSortBy={[{ id: "TariffCode", desc: false }]}
        name="Tariff"
        where={filters}
        onRowClick={({ RecId }) =>
          history.push(`/finance/tariffs/${RecId}/details`)
        }
      />
    </React.Fragment>
  );
};
TariffsPage.propTypes = {};
export default TariffsPage;
